var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import fileUploadConfig from '../../../../const/fileUploadConfig';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { updateAcceptedFiles, updateAdditionalInfoView, updateRejectedFiles, updateSelectedFile, updateUserComment } from '../../../../redux/additionalInfo/additionalInfo.slice';
import { t } from '../../../../strings/i18n/i18n';
import styled from 'styled-components';
import AdditionalInfoComment from '../../../../ui/organisms/AdditionalInfoComment';
import DocumentPreviewList from '../../../../ui/organisms/DocumentPreviewList';
import SectionDescription from '../../../../ui/organisms/SectionDescription';
import UploadDocumentSection from '../../../../ui/organisms/UploadDocumentSection';
import query from 'syf-component-library/const/mediaQueries';
import { spacing } from 'syf-component-library/defaultTheme';
import { Stack } from 'syf-component-library/ui/spacing';
import ErrorSection from '../../../../ui/molecules/ErrorSection';
import AdditionalInfoErrorCodes from '../../../../const/AdditionalInfoErrorCodes';
import theme from '../../../../theme';
import { AdditionalInfoView } from '../../../../redux/additionalInfo/typings';
import useSelectedDispute from '../../../../hooks/useSelectedDispute';
import getTranslationForTransactionDisputeReasonDocs from '../../../../helpers/getTranslationForTransactionDisputeReasonDocs';
var UploadContainer = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 8px;\n  padding: ", "px;\n  @media ", " {\n    padding: ", "px;\n  }\n"], ["\n  background-color: ", ";\n  border-radius: 8px;\n  padding: ", "px;\n  @media ", " {\n    padding: ", "px;\n  }\n"])), theme.colors.greyNinetyEight, spacing.large, query.greaterThanMedium, spacing.xlarge);
var disallowedFilenameCharRegex = /[^0-9a-zA-Z!.,#@$-=()[\] ]/;
var AdditionalInfoUpload = function () {
    var _a = useSelector(function (state) { return state; }, shallowEqual), _b = _a.additionalInfo, userComment = _b.userComment, acceptedFiles = _b.acceptedFiles, rejectedFiles = _b.rejectedFiles, userCommentError = _b.userCommentError, maxFilesReached = _b.maxFilesReached, docsRequested = _a.featureFlags.docsRequested;
    var selectedTransaction = useSelectedDispute().selectedTransaction;
    var disputeReason = selectedTransaction.disputeReason;
    var uploadErrors = useSelector(function (_a) {
        var additionalInfo = _a.additionalInfo;
        var rejectedFilesErrors = additionalInfo.rejectedFilesErrors, apiError = additionalInfo.apiError;
        if (apiError) {
            return __spreadArray([apiError], rejectedFilesErrors, true);
        }
        return rejectedFilesErrors;
    });
    var dispatch = useDispatch();
    var supportedFileTypes = fileUploadConfig.supportedFileTypes;
    var getSectionDescription = function () {
        var defaultDescription = t('additionalInfo.documentSectionDescription');
        var dynamicDocsRequested = t(getTranslationForTransactionDisputeReasonDocs(disputeReason));
        return (docsRequested && dynamicDocsRequested) || defaultDescription;
    };
    var handleCommentChange = function (event) {
        dispatch(updateUserComment({ userComment: event.target.value }));
    };
    var handleDeleteDocument = function (selectedFile) {
        dispatch(updateSelectedFile(selectedFile));
        dispatch(updateAdditionalInfoView({
            currentView: AdditionalInfoView.DeleteConfirmation
        }));
    };
    var onDrop = function (files) {
        dispatch(updateAcceptedFiles(files));
    };
    var onDropRejected = function (files) {
        dispatch(updateRejectedFiles(files));
    };
    var validateDocumentType = function (file) {
        if (!supportedFileTypes.includes(file.type)) {
            return {
                code: AdditionalInfoErrorCodes.FileInvalidType,
                message: t('additionalInfo.unsupportedFileType')
            };
        }
        var disallowedFilename = disallowedFilenameCharRegex.test(file.name);
        if (disallowedFilename) {
            return {
                code: AdditionalInfoErrorCodes.InvalidFileName,
                message: t('additionalInfo.invalidFileName')
            };
        }
        var fileName = file.name.slice(0, file.name.lastIndexOf('.'));
        var disallowedFileCharCount = fileName.length > 100;
        if (disallowedFileCharCount) {
            return {
                code: AdditionalInfoErrorCodes.FileNameTooLong,
                message: t('additionalInfo.invalidFileNameLength')
            };
        }
        return null;
    };
    return (_jsxs("div", __assign({ "data-cy": "additional-info-upload" }, { children: [uploadErrors.map(function (errorText) { return (_jsx(ErrorSection, { errorText: errorText }, errorText)); }), _jsx(SectionDescription, { "data-cy": "upload-documents-section", sectionHeading: t('additionalInfo.documentSectionTitle'), sectionDescription: getSectionDescription(), size: "medium" }), _jsxs(UploadContainer, { children: [_jsx(UploadDocumentSection, { onDrop: onDrop, onDropRejected: onDropRejected, validator: validateDocumentType, maxFilesReached: maxFilesReached }), _jsx(Stack, { size: "large" }), _jsx(DocumentPreviewList, { uploadFiles: acceptedFiles, rejectedFiles: rejectedFiles, loading: false, isLoadingForRejected: false, onDelete: handleDeleteDocument, totalFileSize: 0 })] }), _jsx(AdditionalInfoComment, { userComment: userComment, userCommentError: userCommentError, handleChange: handleCommentChange })] })));
};
export default AdditionalInfoUpload;
var templateObject_1;
//# sourceMappingURL=index.js.map